// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3HGIE","content":"styles_content__2MP2P"};